import axios from 'axios'

export const state = {
  roles: [],
  new_org: {},
  current_role: {},
  editable_role: {}
}

export const getters = {
  getRoles: state => { return state.roles },
  getCurrentRole: state => { return state.current_role },
  getEditableRole: state => { return state.editable_role }
}

export const mutations = {
  setRoles (state, payload) { state.roles = payload },
  setNewRole (state, payload) { state.roles.unshift(payload) },
  setCurrentRole (state, payload) { state.current_role = payload },
  setEditableRole (state, payload) { state.editable_role = payload }
}

export const actions = {
  async loadRoles ({ commit }, payload) {
    const uri = '/api/roles'
    await axios.get(uri)
        .then(response => {
          commit('setRoles', response.data)
          commit('setCurrentRole', null)
        })
        .catch(err => { console.log('Roles error ', err) })
  },

  storeRole ({ commit }, payload) {
    const uri = '/api/roles'
    axios.post(uri, payload)
        .then(response => { commit('setNewRole', response.data) })
        .catch(err => { console.log('New role error ', err) })
  },

  updateRole ({ commit }, payload) {
    const uri = '/api/roles/' + payload.id
    axios.put(uri, payload)
        .then(response => { commit('setNewRole', response.data) })
        .catch(err => { console.log('Update role error ', err) })
  },

  deleteRole ({ commit }, payload) {
    axios.delete(`/api/roles/${payload}`)
        .then(response => { })
        .catch(err => { console.log('Delete role error ', err) })
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/roles.js